import { useQuery } from "@tanstack/react-query"
import { AuthUser, getCurrentUser } from "aws-amplify/auth"

const getUser = async (): Promise<AuthUser> => {
  const user = await getCurrentUser()
  return user
}

export const useCurrentUserQuery = () => {
  const { data, isLoading, error, isPending, isError } = useQuery({
    queryKey: ["currentUser"],
    queryFn: () => getUser(),
  })

  return { currentUser: data as AuthUser, isLoading, error, isPending, isError }
}
